<script setup lang="ts">
  import { SlashIcon } from '@heroicons/vue/24/outline'
  import { type Topic, type Page, type Setting } from '@/components/app/settings/SettingsBase.vue'

  import { inject, ref, type Ref } from 'vue'

  // Inject dependencies as Refs
  const selectedTopic = inject<Ref<Topic | null>>('selectedTopic', ref(null))
  const selectedSetting = inject<Ref<Setting | null>>('selectedSetting', ref(null))
  const selectedPage = inject<Ref<Page | null>>('selectedPage', ref(null))
</script>
<template>
  <div class="border-b-[1px]">
    <div class="flex h-[70px] items-center ps-4">
      <slot name="header">
        <div
          class="flex w-full items-center justify-between font-semibold text-gray-800 dark:text-neutral-200"
        >
          <slot name="breadcrumbs">
            <ol class="flex items-center whitespace-nowrap">
              <li class="inline-flex items-center">
                <span class="flex items-center text-sm text-gray-500 focus:outline-none">
                  {{ selectedTopic ? selectedTopic.name : '' }}
                </span>
                <SlashIcon class="size-5 shrink-0 text-gray-400" />
              </li>
              <li
                v-if="selectedSetting && selectedSetting.name !== selectedPage?.name"
                class="inline-flex items-center"
              >
                <span class="flex items-center text-sm text-gray-500 focus:outline-none">
                  {{ selectedSetting ? selectedSetting.name : '' }}
                </span>
                <SlashIcon class="size-5 shrink-0 text-gray-500" />
              </li>
              <li class="inline-flex items-center truncate text-sm font-semibold text-gray-800">
                {{ selectedPage ? selectedPage.name : '' }}
              </li>
              <slot name="breadcrumbs-end"></slot>
            </ol>
          </slot>
          <slot name="actions"></slot>
        </div>
      </slot>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-12">
    <div class="col-span-12 p-5 pe-0">
      <div
        class="flex flex-col rounded-xl border border-gray-200 bg-white shadow-[0_4px_6px_0px_rgba(0,0,0,0.03)]
          dark:border-neutral-700 dark:bg-neutral-800 xl:col-span-2"
      >
        <div class="h-full px-5 py-4">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
